import React from "react";
import { useAuth } from "../contexts/authContext";
import { Navigate } from "react-router-dom";

function ProtectedRoute({children, requiredRole})
{
    const {currentUser, role}=useAuth();

    if(requiredRole === "shelter")
    {
        if(!currentUser || role !== "shelter")
        {
            return <Navigate to="/"/>;
        }
    }
    else
    {
        if(currentUser&& role === "shelter")
        {
            return <Navigate to="/shelter-dashboard"/>;
        }
    }
    return children;
}

export default ProtectedRoute;